module.exports = {
      id: "compass-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.91580017.svg#compass-usage",
      toString: function () {
        return this.url;
      }
    }